import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { CNPJValidate, CPFValidate } from 'src/app/helpers/documents-utils';
import { PersonDocumentType } from 'src/app/services/models/enums';

@Directive({
    selector: '[appCpfCnpjValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CpfCnpjValidatorDirective, multi: true }],
    standalone: false
})
export class CpfCnpjValidatorDirective implements Validator {
  @Input() appCpfCnpjValidator!: PersonDocumentType;

  validate(control: AbstractControl): ValidationErrors | null {
    const cpfCnpj: string = control.value;

    if (!cpfCnpj) return null;

    if (this.appCpfCnpjValidator === PersonDocumentType.CPF) {
      return CPFValidate(cpfCnpj) ? null : { invalidCPFCNPJ: true }
    } else {
      return CNPJValidate(cpfCnpj) ? null : { invalidCPFCNPJ: true }
    }
  }
}
